import type { MilestoneMapInterval } from '../types/MilestoneMap1';

// Order from finest to coarsest granularity
export const ZOOM_LEVELS: MilestoneMapInterval[] = [
  'hours',
  'days',
  'weeks',
  'months',
  'quarters',
  'years',
];

/**
 * Determines if one interval type is coarser than another
 */
export function isCoarserInterval(a: MilestoneMapInterval, b: MilestoneMapInterval): boolean {
  return ZOOM_LEVELS.indexOf(a) > ZOOM_LEVELS.indexOf(b);
}

/**
 * Determines if one interval type is finer than another
 */
export function isFinerInterval(a: MilestoneMapInterval, b: MilestoneMapInterval): boolean {
  return isCoarserInterval(b, a);
}
